import React from 'react';
import './style.scss';
import { SearchIcon } from 'components/Icons/Glyphs';

export default props => <div className='zt-search'><input {...props} className='zt-search__input' /><SearchIcon className='zt-search__icon' /></div>